import styled from 'styled-components';

const Container = styled.div``;

const TutorialContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding-bottom: 32px;
  text-align: center;

  @media (min-width: 361px) {
    // width: 360px;
  }
`;

const IconClose = styled.div`
  display: flex;
  flex-direction: row-reverse;
  padding-top: 16px;
  padding-right: 18.7px;
`;

const IconUtp = styled.div`
  display: flex;
  justify-content: center;
  height: 88px;
  width: 100%;
  left: 0px;
  top: 0px;
  border-radius: 0px;
`;

const TextUtp = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 16px 40px 16px;
`;

const HelloUtp = styled.p`
  font-size: 20px;
  line-height: 32px;
  font-weight: 900;
`;

const PortalUtp = styled.p`
  padding: 16px 16px 0px 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  @media (min-width: 361px) {
    padding: 16px 32px 0px 32px;
  }
`;

const ButtonStart = styled.button`
  margin-bottom: 16px;
  background: #5b36f2;
  border-radius: 4px;
  padding: 10px 16px;
  color: white;
  width: 248px;
  height: 40px;

  &:hover {
    background: #745ef6;
    cursor: pointer;
  }

  &:focus {
    background: #4318cd;
  }

  &:active {
    background: #4318cd;
  }

  @media (min-width: 361px) {
    width: 115px;
    height: 40px;
    margin-right: 16px;
    margin-bottom: 0px;
  }
`;

const ButtonFinish = styled.button`
  border-radius: 4px;
  border: 1px solid #5b36f2;
  padding: 10px 16px;
  color: #5b36f2;
  font-weight: 700;
  width: 248px;
  height: 40px;

  &:hover {
    background: #e2dffd;
    cursor: pointer;
  }

  &:focus {
    background: #c6c0fc;
  }

  &:active {
    background: #c6c0fc;
  }

  @media (min-width: 361px) {
    width: auto;
    height: 40px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  //   width: 100%;

  @media (min-width: 361px) {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: center;
  }
`;

export {
  Container,
  TutorialContainer,
  IconClose,
  IconUtp,
  TextUtp,
  HelloUtp,
  PortalUtp,
  ButtonStart,
  ButtonFinish,
  ButtonContainer
};
